/* eslint-disable import/no-anonymous-default-export */
import React from 'react';
import './styles.scss';
import { ReactComponent as CommentIcon } from '../../../../public/post-icons/comments-icon.svg';
import { ReactComponent as PlayOffIcon } from '../../../../public/post-icons/play-off-icon.svg';
import { ReactComponent as ShareIcon } from '../../../../public/post-icons/share-icon.svg';
import { ReactComponent as AddToPlayListIcon } from '../../../../public/shared/add-icon.svg';

import { like, unlike } from '../../../../api/likes';
import { log_error } from '../../../../api';
import SharingModal from '../../../shared/SharingModal';
import Comments from '../Comments';
import { commentables } from '../../../../api/comments';
import AddTrackToPlayistModal from '../MediaTag/AudioTag/AddTrackToPlaylistModal';
import HeartOutline from '../../../../components/shared/Svg/HeartOutline';
import HeartFilled from '../../../../components/shared/Svg/HeartFilled';

export default (props) => {
  const actions = {
    onLikePost: (id) =>
      props.setObject({
        ...props.object,
        is_liked: true,
        likes_count: props.object.likes_count + 1,
      }),
    onUnlikePost: (id) =>
      props.setObject({
        ...props.object,
        is_liked: false,
        likes_count: props.object.likes_count - 1,
      }),
    onDeletePost: (id) => props.setObject(null),
    onAddComment: (post_id, comment) => {
      props.setObject({
        ...props.object,
        comments: [...props.object.comments, comment],
        comments_count: props.object.comments_count + 1,
      });
    },
    onRemoveComment: (post_id, comment_id) => {
      props.setObject({
        ...props.object,
        comments: props.object.comments.filter((a) => a.id !== comment_id),
        comments_count: props.object.comments_count - 1,
      });
    },
  };

  const renderPlayCount = () => {
    if (
      //props.object.play_count !== null &&
      //props.object.play_count !== undefined
      props.object.attachments &&
      props.object.attachments.length > 0 &&
      props.object.attachments[0].type === 'SoundTrack'
    ) {
      return (
        <div className="play mr-1">
          <PlayOffIcon />
          <small className="text-default ml-1">{props.object.attachments[0].play_count}</small>
        </div>
      );
    }
    if (
      props.object.attachments &&
      props.object.attachments.length > 0 &&
      props.object.attachments[0].type === 'Video'
    ) {
      return (
        <div className="play mr-1">
          <PlayOffIcon />
          <small className="text-default ml-1">
            {props.object.attachments[0].play_count}
          </small>
        </div>
      );
    }

    return null;
  };

  const handleHeart = async () => {
    try {
      if (props.object.is_liked) {
        await unlike(props.object.type, props.object.id);
        actions.onUnlikePost(props.object.id);
      } else {
        await like(props.object.type, props.object.id);
        actions.onLikePost(props.object.id);
      }
    } catch (error) {
      log_error(error);
    }
  };
  const original_object = (object) =>
    object.type === 'Post' && object.attachments.some((a) => a.type === 'Post')
      ? original_object(object.attachments.find((a) => a.type === 'Post'))
      : object;

  return (
    <div className="actions-container">
      <div className={`actions d-flex justify-content-between ${props.object.type === 'SoundTrack' ? "sound_track_icon": null }`}>
        {renderPlayCount()}
        <div
          className={`heart mr-1 ${window.location.pathname.indexOf('sound_track') > 0 ? "heart-mt" : "heart-mt-zero"} action ${props.object.is_liked && 'active'}`}
          onClick={handleHeart}
        >
          {props.object.is_liked ? (
            <HeartFilled  color="#f0047f" />
          ) : (
            <HeartOutline  color="#000" />
          )}

          <small className="text-default ml-1">
            {props.object.likes_count}
          </small>
        </div>
        <SharingModal
          onSubmit={props.refresh}
          attachments={[original_object(props.object)]}
        >
          <div className="share mr-1 action">
            <ShareIcon />
            <small className="text-default ml-1">
              {props.object.shared_count}
            </small>
          </div>
        </SharingModal>

        {props.object.type === 'SoundTrack' && (
          <AddTrackToPlayistModal user={props.user} medium={props.object}>
            <AddToPlayListIcon className="add-to-playlist" />
          </AddTrackToPlayistModal>
        )}

        {commentables.includes(props.object.type) && (
          <div className={`comment mr-1 action active`}>
            <CommentIcon />
            <small className="text-default ml-1">
              {props.object.comments_count}
            </small>
          </div>
        )}
      </div>
      {commentables.includes(props.object.type) && (
        <Comments object={props.object} actions={actions} />
      )}
    </div>
  );
};
